import React from "react";
import { Popconfirm, InputNumber } from "antd";
import { SALE_MAX, SALE_MIN } from "../../Pages/Products/sale";
import ToggleButton from "../ToggleButton";

export default function SaleToggle({ item, onChange }) {
  const [discount, setDiscount] = React.useState(item.sale_discount || null);
  const onSale = !!item.on_sale;
  const confirm = onSale
    ? { title: "Switch sale off?", okText: "Switch off", onConfirm: () => onChange(false) }
    : {
        title: (
          <div>
            <div>Sale discount %</div>
            <InputNumber min={SALE_MIN} max={SALE_MAX} precision={0} value={discount} onChange={setDiscount} />
          </div>
        ),
        okText: "Switch on",
        okButtonProps: { disabled: !discount },
        onConfirm: () => onChange(true, discount),
      };

  return (
    <Popconfirm {...confirm}>
      <span className="pc-sale-trigger">
        <ToggleButton ariaLabel="sale" checked={onSale} />
      </span>
    </Popconfirm>
  );
}
